<div class="itb-select-wrapper" [formGroup]="parentForm">
    <mat-form-field> 
        <mat-label>{{label}}</mat-label>
        <mat-select #infiniteSelect (openedChange)="triggerEvent($event)" [formControlName]="formFieldName" (selectionChange)="changeEvent($event)">
            <div class="infinite-select-content" #infiniteContent>
                <itb-input [isReactive]="false" [label]="'Search'" (onChangeHandler)="onInputChangeHandler($event)" (keydown)="$event.stopPropagation()"></itb-input>
                <div *ngIf="isSearching" class="infinite-select-loader lp"><itb-spinner [spinnerType]="'m'"></itb-spinner></div>
                <div *ngIf="!isSearching">
                    <mat-optgroup *ngFor="let group of items" [label]="group.title + ' (' + group.count + ')'"
                    [disabled]="group.isDisabled">
                    <mat-option *ngFor="let option of group.options" [value]="option.id">
                    {{option.title}}
                    </mat-option>
                </mat-optgroup>
                <div *ngIf="isLoading" class="infinite-select-loader"><itb-spinner [spinnerType]="'s'"></itb-spinner></div>
                </div>
        </div>
        </mat-select>
    </mat-form-field>
</div>